import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-reportar-error-dialog',
  standalone: true,
  imports: [DialogModule, ReactiveFormsModule, FileUploadModule, InputTextModule, TextareaModule, ButtonModule],
  templateUrl: './reportar-error-dialog.component.html',
  styleUrl: './reportar-error-dialog.component.scss',
})
export class ReportarErrorDialogComponent {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  private readonly fb = inject(FormBuilder);

  form = this.fb.group({
    titulo: ['', Validators.required],
    descripcion: ['', Validators.required],
  });

  enviar() {
    if (this.form.valid) {
      console.log('Mock report:', this.form.value);
      this.visible = false;
    }
  }

  cerrar() {
    this.visible = false;
    this.visibleChange.emit(false);
  }
}
